import { render, staticRenderFns } from "./JsonFormArray.vue?vue&type=template&id=60aa4753&scoped=true"
import script from "./JsonFormArray.vue?vue&type=script&lang=ts"
export * from "./JsonFormArray.vue?vue&type=script&lang=ts"
import style0 from "./JsonFormArray.vue?vue&type=style&index=0&id=60aa4753&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aa4753",
  null
  
)

export default component.exports